<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Facturación</h6>
                </div>
                <div class="col-md-8">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                            <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control"
                            v-model="searchTerm"
                            :placeholder="
                                this.$store.state.isRTL ? 'أكتب هنا...' : 'Buscar...'
                            "
                        />
                    </div>
                </div>
                <div class="col-md-2 ">
                        <argon-button
                        class="mt-0"
                        color="info"
                        fullWidth
                        size="xs"
                        @click="toCreate"
                        >Agregar Nueva</argon-button> 
                </div> 
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Código
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Cliente
                            </th>
                            <th
                                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >
                                NIT Cliente
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Tipo Cliente
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Tipo Factura
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Fecha Emisión
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Subtotal
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Impuestos
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Total
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Estado
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(invoice, index) in filteredRows"
                            :key="index"
                        > 
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ invoice.full_number }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ invoice.client_name }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ invoice.client_nit }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ invoice.client_type }} <!-- Tipo del cliente (enriquecido de clients) -->
                                </p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ invoice.invoice_type === 'FACTURA' ? 'Factura' : 'Ticket' }}
                                </p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ invoice.date_issued }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">${{ invoice.subtotal.toFixed(2) }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">${{ invoice.total_taxes.toFixed(2) }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">${{ invoice.total.toFixed(2) }}</p>
                            </td>
                            <td>
                                <span 
                                    class="text-xs font-weight-bold mb-0"
                                    :class="invoice.state === 'EMITTED' ? 'text-warning' : invoice.state === 'PAID' ? 'text-success' : 'text-danger'"
                                >
                                    {{ invoice.state === 'EMITTED' ? 'Emitida' : invoice.state === 'PAID' ? 'Pagada' : 'Cancelada' }}
                                </span>
                            </td>
                            <td class="align-middle">
                                <a
                                    :href="'view-invoice/' + invoice.id"
                                    class="btn bg-success mx-2"
                                    data-toggle="tooltip"
                                    data-original-title="Ver factura"
                                >
                                    <i class="fa fa-eye text-white text-sm opacity-10"></i>
                                </a>
                                <!-- Puedes agregar más acciones si es necesario -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";

export default {
    name: "facturas-table",
    props: {
        clients: {
            type: Array,
            required: true
        },
        invoices: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            searchTerm: null,
            combinedInvoices: []  // Array combinado se calculará aquí
        };
    },
    components: { ArgonButton },
    computed: {
        filteredRows() {
            if (!this.searchTerm) {
                return this.combinedInvoices;
            } else {
                const searchLower = this.searchTerm.toLowerCase();
                return this.combinedInvoices.filter(invoice => {
                    const fullNumber = invoice.full_number.toString().toLowerCase();
                    const clientName = invoice.client_name.toString().toLowerCase();
                    const clientNit = invoice.client_nit.toString().toLowerCase();
                    const clientType = invoice.client_type.toString().toLowerCase();
                    return fullNumber.includes(searchLower) || 
                           clientName.includes(searchLower) || 
                           clientNit.includes(searchLower) ||
                           clientType.includes(searchLower);
                });
            }
        }
    },
    watch: {
        // Observar cambios en clients o invoices para recalcular la combinación
        clients: {
            handler() {
                this.combineData();
            },
            deep: true
        },
        invoices: {
            handler() {
                this.combineData();
            },
            deep: true
        }
    },
    mounted() {
        this.combineData();  // Calcular la combinación inicial al montar el componente
    },
    methods: {
        combineData() {
            // Función para combinar clients e invoices por client_id
            // Enriquecemos cada invoice con el objeto client completo y agregamos campos derivados como client_type
            this.combinedInvoices = this.invoices.map(invoice => {
                const client = this.clients.find(c => c.id === invoice.client_id);
                return {
                    ...invoice,  // Copia todos los campos del invoice
                    client: client || null,  // Objeto client completo (para uso futuro, ej. email, phone)
                    client_type: client ? client.type : 'DESCONOCIDO'  // Campo derivado para la tabla (NATURAL/JURIDICA)
                };
            }).filter(invoice => invoice.client !== null);  // Opcional: filtrar facturas sin client matching
        },
        toCreate() {
            this.$router.push('/create-invoice');  // Ajustado para nueva factura
        },
    },
};
</script>